export const environment = {
  production: true,
  baseUrl: "https://dospu1.unsl.edu.ar/dospuServicio",
};
